// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// Copyright (c) 2022, Business Centric Network Company Limited and Contributors
// MIT License. See license.txt

frappe.provide('bcn.web');

$.extend(bcn.web, {
	/*
	 * Variables
	 */
	/*
	$preloader: null,
	$navbar: null,
	$banner: null,
	$breadcrumbs: null,
	$sidebar: null,
	$main: null,
	$footer: null,
	*/
	$preloader: $('.preloader'),
	$banner: $('.web-banner'),
	$navbar: $('nav.navbar'),
	$sidebar: $('.web-sidebar'),
	$breadcrumbs: $('.page-content-wrapper .page-breadcrumbs'),
	$main: $('.page-content-wrapper main'),
	$footer: $('footer.web-footer'),

	debug: 0,
	_handlers: [],
	_unloading: 0,
	_scrollTop: 0,
	_scrollBottom: 0,
	_atBottom: false,
	_vw: $(window).width(),
	_vh: $(window).height(),

	/*
	* Bind object events
	*/
	on(n, f) {
		if (n && f) {
			var h = bcn.web._handlers[n] || [];
			h.push(f);
			bcn.web._handlers[n] = h;
		}
	},

	trigger() {
		if (arguments.length > 1) {
			var args = arguments;
			var h = bcn.web._handlers[args[0]] || [];
			h.forEach(function(f){
				f.apply(null, args);
			});
		}
	},

	isUnloading() {
		return (bcn.web._unloading === 1);
	},

	toggleUnloading(v) {
		bcn.web._unloading = v;
	},

	/*
	* Preloader
	*/
	//Hide Preloader
	hidePreloader(delay = 300) {
		if (!bcn.web.$preloader) return;
		// preloader is fadeOut after delay	s
		bcn.web.$preloader.delay(delay).fadeOut('slow');
	},

	//Show Preloader
	showPreloader() {
		if (!bcn.web.$preloader) return;
		bcn.web.$preloader.show();
	},

	// Bind global events
	bindGlobalEvents() {
		$(window).on("load", function () {
			//bcn.web.playPrimarySlider();
		});

		$(window).on('beforeunload', function () {
			//bcn.web.toggleUnloading(1);
			//bcn.web.showPreloader();
		});

		$(window).on('unload', function () {
			//bcn.web.toggleUnloading(0);
		});

		$(window).on("scroll", frappe.utils.debounce(function (e) {
			bcn.web.syncScroll();
			bcn.web.hideDropdowns();
		}));

		$(window).on("resize", frappe.utils.debounce(function (e) {
			bcn.web.syncViewport();
			bcn.web.syncScroll();
			//bcn.web.syncSidebarCollapse();
		}, 50));

		$(window).on("focus", frappe.utils.debounce(function (e) {
			//if (bcn.web.isUnloading()) {
			//	bcn.web.toggleUnloading(0);
			//	return;
			//}
			bcn.web.hidePreloader();
		}, 100));

		$(window).on("blur", function () {
			//bcn.web.toggleUnloading(0);
		});
	},

	// Bind user actions
	bindUserActions() {
		$("body").on('click', '.sign-in', function () {
			bcn.navigate("/login#login");
		});

		$("body").on('click', '.sign-up', function () {
			bcn.navigate("/login#signup");
		});
	},

	bindSubscribeToNewsletter() {
		$("#footer-subscribe-button").click(function() {
			if($("#footer-subscribe-email").val() && validate_email($("#footer-subscribe-email").val())) {
				$("#footer-subscribe-email").attr('disabled', true);
				$("#footer-subscribe-button").html("Sending...")
					.attr("disabled", true);
				bcn.subscribe_to_newsletter({
					email: $("#footer-subscribe-email").val(),
					callback: function(r) {
						if(!r.exc) {
							$("#footer-subscribe-button").html(__("Check your inbox"))
								.attr("disabled", true);
						} else {
							$("#footer-subscribe-button").html(__("Error: Invalid email!"))
								.addClass("btn-danger").attr("disabled", false);
							$("#footer-subscribe-email").val("").attr('disabled', false);
						}
					}
				});
			}
			else
				frappe.msgprint(frappe._("Please enter valid email address"))
		});
	},

	syncScroll() {
		bcn.web._scrollTop = $(window).scrollTop();
		bcn.web._scrollBottom = bcn.web._scrollTop + window.innerHeight;
		bcn.web._atBottom = (bcn.web._scrollBottom == $(document).height());

		//trigger scroll
		bcn.web.trigger('scroll',
			bcn.web._scrollTop,
			bcn.web._scrollBottom,
			bcn.web._atBottom
		);
	},

	syncViewport() {
		bcn.web._vw = $(window).width();
		bcn.web._vh = $(window).height();
	},

	hideDropdowns() {
		$("[data-toggle=dropdown]").dropdown('hide');
	},

	init() {
		bcn.web.bindGlobalEvents();
		bcn.web.bindSubscribeToNewsletter();
		bcn.web.bindUserActions();
		bcn.web.syncScroll();
		bcn.web.syncViewport();
		bcn.web.hidePreloader();
	}
});


frappe.ready(function () {
	setTimeout(function() {
		bcn.web.init();
	}, 1);
});
